document.addEventListener('DOMContentLoaded', function () {
  const countdownTarget = new Date("September 30, 2025 23:59:59").getTime();
  const countdownElement = document.getElementById("countdown-timer");

  if (!countdownElement) return;

  function updateCountdown() {
    const now = new Date().getTime();
    const distance = countdownTarget - now;

    if (distance < 0) {
      countdownElement.innerHTML = "🎉 Giveaway closed!";
      return;
    }

    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));

    countdownElement.innerHTML = `Next Winner Selected In: ${days}d ${hours}h ${minutes}m`;
  }

  updateCountdown(); // initial call
  setInterval(updateCountdown, 60000); // update every 60s
});
